<template>
  <div :is="type" v-if="type"></div>
</template>

<script>
  import $ from 'jquery'
  require('bootstrap/js/src/modal')

  import Callback from './Callback/Callback'
  import FullPage from './FullPage/FullPage'
  import Cart from './Cart/Cart'
  import CartTY from './CartTY/CartTY'
  import Login from './CP/Login'
  import Result from './Result/Result'
  import FastOrder from './FastOrder/FastOrder'
  import OrderPreOrder from './OrderPreOrder/OrderPreOrder'

  export default {
    data() {
      return {
        isModalShow : false,
        type : null
      }
    },
    components : {
      Callback, FullPage, Cart, CartTY, Login, Result, FastOrder, OrderPreOrder
    },
    mounted () {

    },
    methods : {
      setType(type) {
        this.type = type

        return this.$nextTick()
          .then(this.show)
          .then(() => {
            this.getComponent().$nextTick()
              .then(this.getComponent().cleanUp ? this.getComponent().cleanUp() : null)
          })
      },
      getComponent() {
        return this.$children[0]
      },
      show() {
        $(this.$el).modal('show')
      },
      hide() {
        $(this.$el).modal('hide')
      },
      before_send(formData) {

      }
    },
    computed : {

    },
    watch : {

    },
  }
</script>

<style>

</style>
